import { gql } from "@apollo/client";

export const newComplianceDocumentMutation = gql`
    mutation newComplianceDocument($input: NewComplianceDocumentInput!){
        newComplianceDocument(input: $input){
            message
            response
        }
    }
`;

export const newDocumentVersionMutation = gql`
    mutation newDocumentVersion($documentId: String!, $input: NewDocumentVersionInput!){
        newDocumentVersion(documentId: $documentId, input: $input){
            message
            response
        }
    }
`;

// After the browser's PUT to S3: fingerprints the file, replaces the previous version and
// sends the document to the officers it applies to.
export const finalizeDocumentUploadMutation = gql`
    mutation finalizeDocumentUpload($documentId: String!){
        finalizeDocumentUpload(documentId: $documentId){
            message
            response
        }
    }
`;

export const setDocumentAcknowledgementMutation = gql`
    mutation setDocumentAcknowledgement($documentId: String!, $input: DocumentAcknowledgementInput!){
        setDocumentAcknowledgement(documentId: $documentId, input: $input){
            message
            response
        }
    }
`;

export const syncDocumentRecipientsMutation = gql`
    mutation syncDocumentRecipients($documentId: String!){
        syncDocumentRecipients(documentId: $documentId){
            message
            response
        }
    }
`;

export const sendComplianceRemindersMutation = gql`
    mutation sendComplianceReminders($shareIds: [String!]!){
        sendComplianceReminders(shareIds: $shareIds){
            message
            response
        }
    }
`;

export const updateComplianceSettingsMutation = gql`
    mutation updateComplianceSettings($input: ComplianceSettingsInput!){
        updateComplianceSettings(input: $input){
            message
            response
        }
    }
`;

// Audit pack (PDF register or CSV) for one document, one record's documents, or everything.
// Returns { url, fileName } - a short-lived download link.
export const exportComplianceAuditMutation = gql`
    mutation exportComplianceAudit($input: ComplianceExportInput!){
        exportComplianceAudit(input: $input){
            message
            response
        }
    }
`;

// Toolbox Talks: create (returns an attachment upload URL if needed), then publish.
export const newToolboxTalkMutation = gql`
    mutation newToolboxTalk($input: NewToolboxTalkInput!){
        newToolboxTalk(input: $input){
            message
            response
        }
    }
`;

export const publishToolboxTalkMutation = gql`
    mutation publishToolboxTalk($documentId: String!){
        publishToolboxTalk(documentId: $documentId){
            message
            response
        }
    }
`;

export const issueToolboxTalkNowMutation = gql`
    mutation issueToolboxTalkNow($documentId: String!){
        issueToolboxTalkNow(documentId: $documentId){
            message
            response
        }
    }
`;

export const updateToolboxTalkMutation = gql`
    mutation updateToolboxTalk($documentId: String!, $input: UpdateToolboxTalkInput!){
        updateToolboxTalk(documentId: $documentId, input: $input){
            message
            response
        }
    }
`;

// fields on a document for the officer to fill in as they acknowledge it
export const saveDocumentFormFieldsMutation = gql`
    mutation saveDocumentFormFields($documentId: String!, $input: JSON!){
        saveDocumentFormFields(documentId: $documentId, input: $input){
            message
            response
        }
    }
`;

// the officer's side (the app's web view page for a document with fields)
export const markComplianceDocumentViewedMutation = gql`
    mutation markComplianceDocumentViewed($shareId: String!){
        markComplianceDocumentViewed(shareId: $shareId){
            message
            response
        }
    }
`;

export const acknowledgeComplianceDocumentMutation = gql`
    mutation acknowledgeComplianceDocument($input: AcknowledgeDocumentInput!){
        acknowledgeComplianceDocument(input: $input){
            message
            response
        }
    }
`;

// brings an archived document back as it was (the server checks it still can - see restoreCheck);
// a toolbox talk can instead come back as its next issue (asNewIssue)
export const restoreComplianceDocumentMutation = gql`
    mutation restoreComplianceDocument($documentId: String!, $reason: String!, $asNewIssue: Boolean){
        restoreComplianceDocument(documentId: $documentId, reason: $reason, asNewIssue: $asNewIssue){
            message
            response
        }
    }
`;
